import { render } from "./ExpiredPassword.vue?vue&type=template&id=15401900&scoped=true"
import script from "./ExpiredPassword.vue?vue&type=script&lang=js"
export * from "./ExpiredPassword.vue?vue&type=script&lang=js"

import "./ExpiredPassword.vue?vue&type=style&index=0&id=15401900&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15401900"]])

export default __exports__